export * from './decoration-pixelization-list-item.component';
